import type { SelectProps } from 'antd';

export const selectSearchFn: SelectProps['filterOption'] = (input, option) => {
  if (typeof option?.label !== 'string') return true;
  return option?.label?.toLowerCase().indexOf(input.toLowerCase()) >= 0;
};
